import axios, { AxiosInstance } from 'axios'
import interceptors from './interceptors'

import resources, { ResourcesModel } from './resources'

const baseURL = process.env.NEXT_PUBLIC_RATES_RESEARCH_API_URL
const http = axios.create({
  baseURL,
  headers: { 'Cache-Control': 'no-cache' }
})

http.interceptors.request.use(interceptors.request)
http.interceptors.response.use(interceptors.response, interceptors.error)

export default {
  ...http,
  ...Object.entries(resources).reduce(
    (result, [name, resource]) => ({
      ...result,
      [name]: resource(http)
    }),
    {}
  )
} as HttpInterface

interface HttpInterface extends AxiosInstance, ResourcesModel {}
